var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7139 35.2L7.19799 8.82304C7.08986 8.68379 7.02297 8.51699 7.00494 8.34161C6.98691 8.16623 7.01845 7.98931 7.09599 7.83097C7.17352 7.67263 7.29393 7.53923 7.44353 7.44593C7.59312 7.35264 7.7659 7.30319 7.9422 7.30322H11.8359C11.9793 7.30344 12.1207 7.33636 12.2494 7.39948C12.3781 7.4626 12.4907 7.55426 12.5786 7.66748L33.0945 34.0444C33.2026 34.1837 33.2695 34.3505 33.2875 34.5258C33.3056 34.7012 33.274 34.8781 33.1965 35.0365C33.119 35.1948 32.9986 35.3282 32.849 35.4215C32.6994 35.5148 32.5266 35.5643 32.3503 35.5642H28.4565C28.3132 35.564 28.1718 35.5311 28.0431 35.468C27.9144 35.4048 27.8018 35.3132 27.7139 35.2Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7066 7.30322L7.58569 35.5642",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.dc287e93dc1c1a967492fa51ac27c460.svg";
export { ForwardRef as ReactComponent };